__turbopack_context__.v({
  "container": "Vpod-module__Upmq0W__container",
  "containerOuterHidden": "Vpod-module__Upmq0W__containerOuterHidden",
});
